import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const utilityModuleLocaleModule: LocaleModule = {
  name: "utilityModule",
  messages: { en: en, it: it },
};
